import React, { Component } from "react"
import PropTypes from "prop-types"
import isEqual from "lodash/isEqual"
import Highcharts from "highcharts"
import { translate } from "react-i18next"
import ColumnLineChartShape from "../../../state/shapes/ColumnLineChartShape"
import { CHARTS } from "../../../constants"

class ColumnLineChart extends Component {
  componentDidMount = () => {
    this.createChart()
  }

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(this.props.data, nextProps.data)
  }

  componentDidUpdate = () => {
    this.createChart()
  }

  componentWillUnmount = () => {
    this.chart.destroy()
  }

  createChart = () => {
    const chartContainer = this.chartContainerRef

    const {
      xAxisTitle, yAxisTitle, yLineAxisTitle, t, titleKey, subtitleKey
    } = this.props
    const { categories } = this.props.data

    // Filter out the spline line if there's only one set of columns
    let series = [...this.props.data.series]
    if (series.length > 1) {
      const columnSeriesItems = series.filter(item => item.type === "column")

      if (
        columnSeriesItems.length <= 1 &&
        series.filter(item => item.type === "spline").length >= 1
      ) {
        series = columnSeriesItems
      }
    }

    // Create the chart
    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: chartContainer,
        height: CHARTS.standardHeight,
        type: "column",
      },
      lang: {
        contextButtonTitle: t("Common.ChartDownloadOptions"),
      },
      title: {
        text: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        y: -30
      },
      subtitle: {
        text: subtitleKey != null && subtitleKey.length > 0 ? t(subtitleKey) : null,
        y: -15
      },
      credits: {
        enabled: false,
      },
      colors: CHARTS.getColours(categories.length),
      xAxis: {
        categories,
        title: {
          text: xAxisTitle,
        },
      },
      yAxis: [
        {
          tickInterval: 1,
          min: 0,
          title: {
            text: yAxisTitle,
          },
          labels: {
            overflow: "justify",
          },
        },
        {
          min: 0,
          title: {
            text: series.length > 1 ? yLineAxisTitle : undefined,
          },
          labels: {
            overflow: "justify",
          },
          opposite: true,
        },
      ],
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          animation: CHARTS.animationEnabled,
          minPointLength: 2,
        },
      },
      series,
      exporting: {
        enabled: CHARTS.exportEnabled,
        buttons: {
          contextButton: {
            menuItems: CHARTS.exportButtons
          }
        },
        filename: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        chartOptions: CHARTS.exportChartOptions
      }
    })
  }

  render() {
    return (
      <div
        className="chart-container col-md-12"
        ref={(c) => {
          this.chartContainerRef = c
        }}
      />
    )
  }
}

ColumnLineChart.propTypes = {
  data: PropTypes.shape(ColumnLineChartShape).isRequired,
  yAxisTitle: PropTypes.string.isRequired,
  yLineAxisTitle: PropTypes.string.isRequired,
  xAxisTitle: PropTypes.string,
  titleKey: PropTypes.string,
  subtitleKey: PropTypes.string
}

ColumnLineChart.defaultProps = {
  xAxisTitle: undefined,
  titleKey: "",
  subtitleKey: ""
}

export default translate()(ColumnLineChart)



// WEBPACK FOOTER //
// ./src/components/charts/generic/ColumnLineChart.jsx